// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-link {
  font-size: 0.9rem;
  color: var(--color-base-draw);
  margin-left: 1rem;
}
.legal-link:hover {
  color: var(--color-elevated-text);
  cursor: pointer;
  text-decoration: underline;
}

svg.icon {
  height: 1rem;
  margin-right: 0.2rem;
  position: relative;
  top: -0.09rem;
}

.user .email {
  margin-left: 0.5rem;
}
.user .email::before {
  content: "(";
}
.user .email::after {
  content: ")";
}

.logo.passkey {
  fill: var(--color-base-draw);
  height: 3rem;
  position: relative;
  top: -0.25rem;
}

.display-id {
  background: none;
  border: none;
  cursor: default;
  margin-left: 0.3rem;
  margin: 0;
  padding: 0;
  transition: all 1500ms ease-out;
  color: var(--color-base-text);
  fill: var(--color-base-draw);
  stroke: var(--color-base-draw);
}
.display-id:disabled svg.icon {
  opacity: 0.2;
}
.display-id .id-text {
  margin-right: 0.5rem;
}
.display-id svg.icon {
  fill: unset;
  stroke: unset;
}
.display-id.copied, .display-id.copied.error {
  color: var(--color-elevated-success);
  fill: var(--color-elevated-success);
  stroke: var(--color-elevated-success);
  transition: all 100ms linear;
}
.display-id.copied .id-text, .display-id.copied.error .id-text {
  color: unset;
}

.product {
  background: none;
  border: none;
  color: var(--color-elevated-text);
  display: block;
  font-size: 1.4rem;
  position: relative;
  text-align: center;
  margin: 0.5rem auto;
}

.navigation-menu-open .main-content .product {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/style/common.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,6BAAA;EACA,iBAAA;AACF;AAAE;EACE,iCAAA;EACA,eAAA;EACA,0BAAA;AAEJ;;AAEA;EAEE,YAAA;EACA,oBAAA;EACA,kBAAA;EAAoB,aAAA;AACtB;;AAGA;EACE,mBAAA;AAAF;AAEE;EACE,YAAA;AAAJ;AAEE;EACE,YAAA;AAAJ;;AAIA;EACE,4BAAA;EACA,YAAA;EACA,kBAAA;EAAoB,aAAA;AAAtB;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EAeA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,8BAAA;AAdF;AAFE;EACE,YAAA;AAIJ;AADE;EACE,oBAAA;AAGJ;AAAE;EACE,WAAA;EACA,aAAA;AAEJ;AAME;EACE,oCAAA;EACA,mCAAA;EACA,qCAAA;EACA,4BAAA;AAJJ;AAKI;EACE,YAAA;AAHN;;AAQA;EAGE,gBAAA;EACA,YAAA;EACA,iCAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,mBAAA;AARF;;AAaA;EACE,aAAA;AAVF","sourcesContent":[".legal-link {\n  font-size: 0.9rem;\n  color: var(--color-base-draw);\n  margin-left: 1rem;\n  &:hover {\n    color: var(--color-elevated-text);\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\nsvg.icon {\n  // fill: var(--color-elevated-draw);\n  height: 1rem;\n  margin-right: 0.2rem;\n  position: relative; top: -0.09rem;\n  // stroke: var(--color-elevated-draw);\n}\n\n.user .email {\n  margin-left: 0.5rem;\n\n  &::before {\n    content: \"(\";\n  }\n  &::after {\n    content: \")\";\n  }\n}\n\n.logo.passkey {\n  fill: var(--color-base-draw);\n  height: 3rem;\n  position: relative; top: -0.25rem;\n}\n\n.display-id {\n  background: none;\n  border: none;\n  cursor: default;\n  margin-left: 0.3rem;\n  margin: 0;\n  padding: 0;\n\n  &:disabled svg.icon {\n    opacity: 0.2;\n  }\n\n  .id-text {\n    margin-right: 0.5rem;\n  }\n\n  svg.icon {\n    fill: unset;\n    stroke: unset;\n  }\n\n  transition: all 1500ms ease-out;\n  color: var(--color-base-text);\n  fill: var(--color-base-draw);\n  stroke: var(--color-base-draw);\n\n  &.copied, &.copied.error {\n    color: var(--color-elevated-success);\n    fill: var(--color-elevated-success);\n    stroke: var(--color-elevated-success);\n    transition: all 100ms linear;\n    .id-text {\n      color: unset;\n    }\n  }\n}\n\n.product {\n  // animation-direction: normal;\n  // animation-iteration-count: 1;\n  background: none;\n  border: none;\n  color: var(--color-elevated-text);\n  display: block;\n  font-size: 1.4rem;\n  // margin-bottom: 1.1rem;\n  position: relative;\n  text-align: center;\n  margin: 0.5rem auto;\n  // top: 0.5rem;\n  // width: 13rem;\n}\n\n.navigation-menu-open .main-content .product {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
